// extracted by mini-css-extract-plugin
export var productImage = "_zh-0";